import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import TagManagerService from 'services/TagManager';

let actions = [];

const Specification = (props) => {
    const [clicked, setClicked] = useState(false);
    const [isMobile, setMobile] = useState(false);
    const [specificationState, setSpecifications] = useState([]);

    const { filter, items, id } = props;

    useEffect(() => {

        document.addEventListener('click', documentClick);

        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        return function cleanup() {
            document.removeEventListener('click', documentClick);

            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }
    });

    useEffect(() => {
        actions.push(PubSub.register('close_specification', close));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const close = (payload) => {
        if ((payload.value && payload.value.id !== id) || !(payload && payload.value)) {
            setClicked(false);
        } 
    }

    const documentClick = (e) => {
        const firstClass = e.target.classList[0];

        if(!isMobile && ((firstClass != 'catalog-aside-nav-title') && (firstClass != 'font-icn'))) {
            setClicked(false);
        }
    }

    const checkViewport = ()  => {
        if(!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 1024;

        if (currentIsMobile !== isMobile) {
            setMobile(currentIsMobile);
        }
    };

    const click = () => {
        setClicked(prevState => !prevState);
        PubSub.dispatch('close_categories');
        PubSub.dispatch('close_brands');
        PubSub.dispatch('close_specification',{id});
    }

    const change = (event, item, id) => {
        if (event && event.target.checked) {
            if (!item || !id) return false;
            item.id = id;
        }

        setSpecifications(specificationState.map(specification => {
            if(specification.Link && specification.Link === item.Link){
                specification.active = event && event.target.checked;
                
                const title_crumbs = specification.Link.charAt(0).toUpperCase() + specification.Link.slice(1).replace(/-/g, " ");
                const categoryProduct = title_crumbs.split('/')[1];

                TagManagerService.menu(categoryProduct, specification.Name, 'Uso');
            }

            return specification;
        }));

        if(!isMobile){
            PubSub.dispatch('filter_setSpecification', { specification: item });
        }
    }

    const cleanBtn = () => {
        filter.clearSpecification();
        let specificationSelect = [];
        setSpecifications(specificationState.map(item => {

            if (item.active === true) {
                specificationSelect.push({name: item.Name});
            }

            item.active = false;

            return item;
        }));

        TagManagerService.cleanFilterMenu('Limpiar filtros', specificationSelect, 'Menú Lateral');

        PubSub.dispatch('catalog_toogleFilter', false);
    }

    const applyBtn = () => {
        PubSub.dispatch('catalog_toogleFilter', false);

        const specifications = specificationState.map(item => {
            return item.active ? item : false;
        }).filter(Boolean);

        const specificationsName = specifications.map(item => {return {name: item.Name}});
        TagManagerService.filterMenu('Aplicar filtros', specificationsName, 'Menú Lateral');

        PubSub.dispatch('filter_setSpecifications', {specifications});
    }

    useEffect(() => {
        setSpecifications(items);
    }, [items]);

    const title = props.title;

    return (
        <div className={'catalog-aside-nav' + (clicked ? ' active' : '')}>
            <div className={"catalog-aside-nav-title-wrap" + (clicked ? ' active ' : '')} onClick={click}>
                <h4 className="catalog-aside-nav-title">{title}</h4>
                {!isMobile && <i className="font-icn arrow-down" />}
                <i className={"catalog-aside-view-more" + (clicked ? ' active ' : '')}>{clicked ? '-' : '+'}</i>
            </div>
            <ul className={'catalog-aside-nav-list specification' + (clicked ? ' active' : '')}>
                {items.map((item, i) =>
                    <li className="catalog-aside-nav-item" key={i}>
                        <label>
                            <input type="checkbox" value={item.Name} checked={item.active || false} onChange={(event) => change(event, item, id)} />
                            <i className={'catalog-aside-nav-checkbox'}></i>
                            {item.Name}
                        </label>
                    </li>)}
            </ul>

            <div className={"catalog-aside-buttons" + (clicked ? ' active ' : '')}>
                <button className="catalog-aside-btn-clean" onClick={cleanBtn}>Limpiar</button>
                <button className="catalog-aside-btn-apply" onClick={applyBtn}>Aplicar</button>
            </div>
        </div>
    )
}

Specification.propTypes = {
    items: PropTypes.array,
    title: PropTypes.string,
    id: PropTypes.number,
    filter: PropTypes.object
};

export default Specification;
